// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"Root_rootContainer__3Plt_"};